var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 15,
    height: 15,
    transform: "translate(1272 340)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    transform: "translate(-1272 -340)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1270.917 339.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M15.8,3.882,13.064,1.129a.966.966,0,0,0-1.362,0l-9.709,9.7L1.106,14.65a.961.961,0,0,0,.933,1.166,1,1,0,0,0,.2,0l3.868-.886,9.7-9.686A.966.966,0,0,0,15.8,3.882ZM5.641,14.09l-3.625.76L2.841,11.3l7.264-7.236,2.8,2.8Zm7.89-7.908-2.8-2.8,1.624-1.614,2.753,2.8Z",
    fill: "#3da4ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEdit);
export default __webpack_public_path__ + "static/media/blue-edit.d21f7c2f3acfe6993aa0f34de497c435.svg";
export { ForwardRef as ReactComponent };